const Plus = ({ color = "var(--grey)" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <g clip-path="url(#clip0_3244_4701)">
        <path
          d="M12.1 5V19"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.09998 12H19.1"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3244_4701">
          <rect
            width="24"
            height="24"
            fill={color}
            transform="translate(0.0999756)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Plus;
